export default "__VITE_ASSET__DSG6I0GW__"